import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  servicesList: null,
  servicesListError: null,
  userLoading: false,
  user: null,
  userDataError: null,
  success: null,
  error: null,
};

export const cpServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CP_SERVICES_LIST_START:
      return {...state, loading: true, servicesListError: null, error: null, };
    case actionTypes.GET_CP_SERVICES_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        servicesListError: null,
        servicesList: action.payload,
      }
    }
    case actionTypes.GET_CP_SERVICES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        servicesListError: action.payload,
        servicesList: null,
      };
      case actionTypes.ADD_CP_SERVICE_START:
      return {...state, loading: true,  error: null, success: null};
    case actionTypes.ADD_CP_SERVICE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error:null,
        success: action.payload.success
      }
    }
    case actionTypes.GET_CP_SERVICES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error:action.payload.error,
        success: null
      };
      case actionTypes.GET_CP_SERVICES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error:action.payload.error,
        success: null
      };
    case actionTypes.CP_SERVICE_MESSAGE_HANDLER:
      return {
        ...state,
        loading: false,
        servicesListError: action.payload,
        userDataError: action.payload,
        error: action.payload,
        success: action.payload,
      };
    default:
      return {...state};
  }
};
